import React, {
  forwardRef,
  MutableRefObject,
  PropsWithChildren,
  RefAttributes,
} from "react";
import NextLink from "next/link";
import { cn } from "helpers/style";
import styles from "./Link.module.scss";
import { UrlObject } from "url";

type Props = PropsWithChildren<{
  href: string | UrlObject;
  as?: string | UrlObject;
  prefetch?: boolean;
  onClick?: (event: React.MouseEvent) => void;
  ariaLabel?: string;
  className?: string;
  target?: string;
}>;

const Link: React.ForwardRefExoticComponent<
  Props & RefAttributes<HTMLAnchorElement>
> = forwardRef<HTMLAnchorElement, Props>(
  (
    { href, as, children, ariaLabel, prefetch, className, ...props },
    ref: MutableRefObject<HTMLAnchorElement>
  ) => {
    return href ? (
      <NextLink href={href} as={as} prefetch={prefetch} passHref legacyBehavior>
        <a
          className={cn(["link", styles.link, className])}
          aria-label={ariaLabel}
          ref={ref}
          {...props}
        >
          {children}
        </a>
      </NextLink>
    ) : (
      <div className={styles.linkText}>
        <a
          className={cn(["link", styles.link, className])}
          ref={ref}
          {...props}
        >
          {children}
        </a>
      </div>
    );
  }
);

Link.displayName = "Link";
export default Link;
